<href [link]="component.link">
    <div class="pos-relative overflow-hidden video-component"
         [ngClass]="[component.ratio || '']">
        @if (component.video_id && !component.video_hide) {
        <shell />
        }

        <!-- image -->
        @if (component.background_image) {
        <img class="w-12 z-1"
             [dfImage]="component.background_image"
             [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
             [ratio]="component.ratio"
             [fill]="!!component.ratio">
        }

        @if (component.video_id && !component.video_hide) {
        <custom-cursor [class.rf]="!!component.ratio"
                       [disabled]="client.isS || client.isM || client.isTouchy"
                       (clicked)="onCursorClick()">
            <ng-template #customCursorContent>
                <local-vimeo-player class="z-2"
                                    [class.rf]="!!component.ratio"
                                    [video-id]="component.video_id"
                                    [autoplay-in-viewport]="component.video_autoplay_in_view"
                                    [autoplay-on-pause]="false"
                                    [background]="component.video_background"
                                    [controls]="component.video_controls"
                                    [muted]="component.video_muted"
                                    [loop]="component.video_loop"
                                    [progressBar]="component.video_progress_bar"
                                    (onPlayerPlay)="handlePlayerPlay($event)"
                                    (onPlayerPause)="handlePlayerPause($event)"
                                    (onPlayerStop)="handlePlayerStop($event)"
                                    (onVideoEnd)="handleVideoEnd()">

                    <!-- play icon -->
                    <ng-template #playButton>
                        <button class="video-icon"
                                *ifSize="'MS'">
                            <i class="col-w icon-play"
                               aria-hidden="true"></i>
                        </button>
                    </ng-template>

                    <!-- pause icon -->
                    <ng-template #pauseButton>
                        <button class="video-icon"
                                *ifSize="'MS'">
                            <i class="col-w icon-pause"
                               aria-hidden="true"></i>
                        </button>
                    </ng-template>

                    <!-- sound control -->
                    <ng-template #customTpl
                                 let-player>
                        @if (!component.video_background) {
                        <video-control-sound [player]="player" />
                        }
                    </ng-template>
                </local-vimeo-player>
            </ng-template>

            <!-- cursor -->
            <ng-template #customCursorIcon>
                @if (player && !player.isPlaying) {
                <i class="col-w icon-play"
                   aria-hidden="true"></i>
                }
                @if (player && player.isPlaying) {
                <i class="col-w icon-pause"
                   aria-hidden="true"></i>
                }
            </ng-template>
        </custom-cursor>
        }
    </div>
</href>